import styled from 'styled-components';
import Icon from '../../../../../_shared/components/Icon';
import Button from '../../../../../_shared/components/Button';

export const StyledFooterWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
`;

export const StyledStatus = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
  color: ${({ theme }) => theme.COLORS.BASE_INVERTED};

  & > .title {
    color: ${({ theme }) => theme.COLORS.NEUTRAL_30};
    margin-right: 3px;
    text-transform: lowercase;
  }
  & > .title::first-letter {
    text-transform: uppercase;
  }
`;

export const StyledFooterModalLink = styled.div`
  display: flex;
  flex-direction: row;
  cursor: pointer;
  font-size: ${({ theme }) => theme.FONT_SIZES.SMALL};
`;

export const StyledFooterModalLinkIcon = styled(Icon).attrs(({ theme }) => ({
  icon: 'TR5-Info',
  color: theme.COLORS.TERTIARY
}))`
  width: 18px;
  height: 18px;
  margin-right: 6px;
`;

export const StyledSecondaryButton = styled(Button.Secondary)`
  font-size: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  line-height: ${({ theme }) => theme.FONT_SIZES.XSMALL};
  min-width: 210px;
`;
